(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["star-cart"] && !Shopify.designMode) return;
  try {
    
(function(){
  var form=document.getElementById('star-cart-form');
  if(!form)return;

  var timer;

  function submitUpdate(){
    clearTimeout(timer);
    timer=setTimeout(function(){
      if(form.requestSubmit){
        var button=document.createElement('button');
        button.type='submit';
        button.name='update';
        button.value='1';
        button.hidden=true;
        form.appendChild(button);
        form.requestSubmit(button);
        button.remove();
      }else{
        form.submit();
      }
    },250);
  }

  form.addEventListener('click',function(event){
    var button=event.target.closest('[data-cart-qty]');
    if(!button)return;

    var index=button.getAttribute('data-index');
    var input=form.querySelector('[data-cart-qty-input][data-index="'+index+'"]');
    if(!input)return;

    var current=parseInt(input.value,10)||0;
    if(button.getAttribute('data-cart-qty')==='plus')current+=1;
    if(button.getAttribute('data-cart-qty')==='minus')current=Math.max(0,current-1);

    input.value=current;
    submitUpdate();
  });

  form.addEventListener('change',function(event){
    if(!event.target.matches('[data-cart-qty-input]'))return;
    var value=parseInt(event.target.value,10);
    if(Number.isNaN(value)||value<0)event.target.value=0;
    submitUpdate();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["star-home"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var wrap = document.getElementById('dynamic-discoveries');
  if (!wrap) return;
  var items = Array.from(wrap.querySelectorAll('.discovery-item'));
  if (!items.length) return;
  var visibleCount = Math.min(6, items.length);
  var start = 0;
  function showSelection() {
    items.forEach(function(item){ item.classList.add('is-hidden'); });
    for (var i = 0; i < visibleCount; i++) {
      items[(start + i) % items.length].classList.remove('is-hidden');
    }
    start = (start + visibleCount) % items.length;
  }
  showSelection();
  if (items.length > visibleCount) setInterval(showSelection, 10000);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["star-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
  var button=event.target.closest('[data-qty-action]');
  if(!button)return;
  var form=button.closest('form');
  if(!form)return;
  var input=form.querySelector('input[name="quantity"]');
  if(!input)return;
  var current=parseInt(input.value,10)||1;
  var min=parseInt(input.min,10)||1;
  if(button.dataset.qtyAction==='plus'){input.value=current+1}
  if(button.dataset.qtyAction==='minus'){input.value=Math.max(min,current-1)}
  input.dispatchEvent(new Event('change',{bubbles:true}));
});

document.addEventListener('change',function(event){
  var select=event.target.closest('[data-star-variant-select]');
  if(!select)return;
  var option=select.options[select.selectedIndex];
  var price=document.querySelector('[data-star-price]');
  if(!option||!price)return;
  price.textContent=option.dataset.price+' دت';
});

(function(){
  var form=document.getElementById('star-product-form');
  var modal=document.querySelector('[data-star-cart-choice]');
  if(!form||!modal)return;

  function openModal(){
    modal.hidden=false;
    document.body.style.overflow='hidden';
  }

  function closeModal(){
    modal.hidden=true;
    document.body.style.overflow='';
  }

  form.addEventListener('submit',function(event){
    event.preventDefault();

    var submit=form.querySelector('[type="submit"]');
    if(submit)submit.disabled=true;

    var formData=new FormData(form);

    fetch('/cart/add.js',{
      method:'POST',
      headers:{'Accept':'application/json'},
      body:formData
    })
    .then(function(response){
      if(!response.ok){throw new Error('cart-add-failed')}
      return response.json();
    })
    .then(function(){
      openModal();
    })
    .catch(function(){
      form.submit();
    })
    .finally(function(){
      if(submit)submit.disabled=false;
    });
  });

  modal.addEventListener('click',function(event){
    if(event.target.closest('[data-star-cart-choice-close]'))closeModal();
    if(event.target.closest('[data-star-continue-shopping]'))closeModal();
  });

  document.addEventListener('keydown',function(event){
    if(event.key==='Escape'&&!modal.hidden)closeModal();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
